var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.308 2.755a.75.75 0 0 1 .546.91l-4.253 17.033a.75.75 0 0 1-1.455-.363l4.253-17.034a.75.75 0 0 1 .91-.546M7.28 6.22a.75.75 0 0 1 0 1.06l-3.97 3.97 3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97a1.5 1.5 0 0 1 0-2.12l3.97-3.97a.75.75 0 0 1 1.06 0M16.72 15.22a.75.75 0 1 0 1.06 1.06l3.97-3.97a1.5 1.5 0 0 0 0-2.12l-3.97-3.97a.75.75 0 0 0-1.06 1.06l3.97 3.97z"
  })));
};
export default SvgCode;